import { withRouter } from 'react-router-dom';

const myWithRouter = (dom: any): any => { return withRouter(dom); };

export default myWithRouter;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/routes/withRouter.ts